import { Component, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { PasswordErrorService } from '../../services';

@Component({
  selector: 'shared-password-input',
  templateUrl: './password-input.html',
  styleUrls: ['./password-input.scss'],
  imports: [ReactiveFormsModule, MatFormField, MatInput, MatError, MatLabel, MatHint, TranslatePipe],
})
export class PasswordInputComponent {
  @Input() control!: FormControl;

  constructor(private passwordErrorService: PasswordErrorService) {}

  getPasswordErr() {
    return this.passwordErrorService.getPasswordErr(this.control);
  }
}
